import React from 'react'

import { MarginProps } from 'styled-system'

import { CircleNotch } from '@phosphor-icons/react'

import { Container } from './styles'

type Props = MarginProps & {
  size?: number
  fullScreen?: boolean
  inverse?: boolean
}

function Loader({ size = 24, fullScreen, inverse, ...rest }: Props) {
  if (fullScreen) {
    return (
      <Container {...rest} fullscreen={fullScreen} inverse={inverse}>
        <CircleNotch size={size} weight="bold" />
      </Container>
    )
  }

  return (
    <Container {...rest} fullscreen={fullScreen} inverse={inverse}>
      <CircleNotch size={size} weight="bold" />
    </Container>
  )
}

export default Loader
